import { CeruleanButton } from 'components/Button'
import Text from 'components/Text'
import messages from 'lang'
import borderRadius from 'polished/lib/shorthands/borderRadius'
import React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import {
  Header,
  ModalCard,
  ModalContainer,
  ModalTitle,
  StyledSeparator
} from 'scenes/Cashflow/styles'
import styled from 'styled-components'
import { screenWidth, theme } from 'utils'

const TrimmedModalCard = styled(ModalCard)`
  height: 17.5rem;
`

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  flex: 1;
  padding: 2rem 2.5rem 0;
  border-radius: ${theme('inputBorderRadius')};
  ${borderRadius('bottom', 0)};

  @media only screen and (max-width: ${screenWidth('sm')}) {
    padding: 1.5rem;
    border-radius: 0;
  }
`

const BodyWrapper = styled(HeaderWrapper)`
  border-radius: ${theme('inputBorderRadius')};
  padding: 1rem 2.5rem;
  ${borderRadius('top', 0)};
`

const SubText = styled(Text)`
  margin: 0 0 2rem;
  align-self: center;
`

const CloseButton = styled(CeruleanButton)`
  align-self: center;
`

type PropsType = {
  hideActivateModal: (e: React.MouseEvent) => void
} & WrappedComponentProps

const Activate = ({ hideActivateModal, intl }: PropsType) => (
  <TrimmedModalCard>
    <Header>
      <ModalTitle>Success!</ModalTitle>
    </Header>
    <StyledSeparator />
    <ModalContainer>
      <BodyWrapper>
        <SubText>You have successfully activated your API key.</SubText>
        <CloseButton e2e='closeButton' onClick={hideActivateModal} type='button'>
          {intl.formatMessage(messages.button_close)}
        </CloseButton>
      </BodyWrapper>
    </ModalContainer>
  </TrimmedModalCard>
)

export default injectIntl(Activate)
